// removed by extract-text-webpack-plugin
module.exports = {"SeverityRed":"SeverityRed--jjGzv","SeverityYellow":"SeverityYellow--22Zec","Cell":"Cell--27RvC"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Home/SensorsExcessesGrid.scss
// module id = 947
// module chunks = 1